import * as ents from '@attain-apps/entities'
import * as markdown from '@attain-apps/fe/web/main/lib/markdown'

import type { Feature } from './feature'

/**
 * Used to render links to DMS models in Markdown
 *
 * @see {@link markdown.Extension.register}
 */
export function registerMarkdownExtension(feature: Feature) {
  markdown.Extension.register('dms-model', ({ body, properties }) => {
    const schema = feature.selectors.schema.asSignal()
    if (!ents.core.dms.models.Id.isId(body)) {
      console.warn(`Invalid DMS model ID in Markdown: ${body}`)
      return { innerHtml: body }
    }
    const model = schema.tryGetModel(body)
    if (!model) {
      return {
        innerHtml: `<strong>${body}</strong> <em>(not available in current context)</em>`,
      }
    }

    return {
      init: element => {
        const nameElement = element.getElementsByClassName('name')[0] as
          | HTMLElement
          | undefined
        if (nameElement) {
          // When clicking the name
          nameElement.onclick = () => {
            const detailsElement = element.getElementsByClassName(
              'details',
            )[0] as HTMLElement | undefined
            // We find the details
            if (detailsElement) {
              // And toggle it between visible & hidden
              detailsElement.hidden = !detailsElement.hidden
            }
          }
        }
      },
      // NOTE: JSON.stringify ensures the results are quoted, which helps
      // prevent XSS, as well as just accidental improper formatting
      innerHtml: `
<strong class="name">${JSON.stringify(model.name)}</strong>
<span class="details" hidden>
  <strong>ID</strong><br/>
  ${JSON.stringify(model.id)}<br/>
  <br/>
  <strong>Name</strong><br/>
  ${JSON.stringify(model.name)}<br/>
  <br/>
  <strong>Description</strong><br/>
  ${JSON.stringify(model.description)}<br/>
  <br/>
  ${properties.note ? `<span><em>${JSON.stringify(properties.note)}</em></span>` : ''}
</span>
`,
      styles: `
.name {
  cursor: pointer;
}
.details {
  position: absolute;
  background: white;
  padding: 20px;
  border-radius: 5px;
  border: solid gray 1px;
}`,
    }
  })
}
